const validate = (values, props) => {
  const errors = {};
  if (!values.phoneNumber) {
    errors.phoneNumber = 'Champ requis';
  }
  if (
    values.phoneNumber &&
    props.currentUser.phoneNumber === values.phoneNumber
  ) {
    errors.phoneNumber = "Votre numéro de téléphone n'a pas changé";
  }
  return errors;
};

export default validate;
